import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '10px',
    border: '1.5px solid #E5E7EB',
    fontSize: '15px',
    outline: 'none',
    boxSizing: 'border-box',
}

export default function ChangePassword() {
    const { user, token, updateSession, logout } = useAuth()
    const navigate = useNavigate()
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmation, setConfirmation] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    if (!user) return <Navigate to="/login" replace />
    if (!user.must_change_password) return <Navigate to="/" replace />

    const submit = async () => {
        setError('')
        if (newPassword.length < 8) {
            setError('Новый пароль должен содержать не менее 8 символов')
            return
        }
        if (newPassword !== confirmation) {
            setError('Новые пароли не совпадают')
            return
        }

        setLoading(true)
        try {
            const response = await fetch('/api/auth/change-password', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    current_password: currentPassword,
                    new_password: newPassword,
                }),
            })
            const data = await response.json()
            if (!response.ok) {
                setError(data.message || 'Не удалось изменить пароль')
                return
            }
            updateSession({ ...user, must_change_password: false }, data.token)
            navigate('/', { replace: true })
        } catch {
            setError('Ошибка соединения с сервером')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div style={{ minHeight: '100vh', background: '#F2F4F7', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', boxSizing: 'border-box' }}>
            <div style={{ background: 'white', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '400px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
                <div style={{ textAlign: 'center', marginBottom: '28px' }}>
                    <img src="/logo.png" alt="CoFresh" style={{ height: '24px', marginBottom: '16px', filter: 'invert(1)' }} />
                    <h1 style={{ margin: '0 0 8px', fontSize: '22px', color: '#111827' }}>Установите новый пароль</h1>
                    <p style={{ color: '#6B7280', fontSize: '14px', lineHeight: '1.4' }}>Временный пароль необходимо заменить перед началом работы.</p>
                </div>

                {error && <div style={{ background: '#FEF2F2', color: '#DC2626', fontSize: '14px', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px' }}>{error}</div>}

                {[
                    ['Текущий пароль', currentPassword, setCurrentPassword],
                    ['Новый пароль', newPassword, setNewPassword],
                    ['Повторите новый пароль', confirmation, setConfirmation],
                ].map(([label, value, setter]) => (
                    <label key={label} style={{ display: 'block', marginBottom: '16px' }}>
                        <span style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>{label}</span>
                        <input
                            type="password"
                            value={value}
                            onChange={(event) => setter(event.target.value)}
                            onKeyDown={(event) => event.key === 'Enter' && submit()}
                            autoComplete={label === 'Текущий пароль' ? 'current-password' : 'new-password'}
                            style={inputStyle}
                        />
                    </label>
                ))}

                <button type="button" onClick={submit} disabled={loading} style={{ width: '100%', padding: '14px', background: loading ? '#93AEFF' : '#0052FF', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer' }}>
                    {loading ? 'Сохраняем...' : 'Сохранить новый пароль'}
                </button>
                <button type="button" onClick={logout} style={{ width: '100%', marginTop: '10px', padding: '10px', background: 'transparent', color: '#6B7280', border: 'none', cursor: 'pointer' }}>
                    Выйти
                </button>
            </div>
        </div>
    )
}
